jQuery(document).ready(function($) {
    'use strict';
    $(window).scroll(function() {
        $('.scroll-in-view').each(function() {
            var top_of_element = $(this).offset().top;
            var bottom_of_element = $(this).offset().top +
                $(this).outerHeight();
            var bottom_of_screen = $(window).scrollTop() +
                $(window).innerHeight() -
                ($(window).innerHeight() * 0.5); // 50% of window height
            var top_of_screen = $(window).scrollTop();
            if ((bottom_of_screen > top_of_element) &&
                (top_of_screen < bottom_of_element) &&
                !$(this).hasClass('is-visible')) {
                $(this).addClass('is-visible'); // Add is-visible class immediately
                // Add is-visible-delay class after a delay of 1000ms
                var $element = $(this);
                setTimeout(function() {
                    $element.addClass('is-visible-delay');
                }, 800);
            }
        });
    });
});
//# sourceMappingURL=scroll-in-view.js.map
